import React from "react";

import { Navigate } from 'react-router-dom'

export function PrivateRoute({children}) {
    
    const user = JSON.parse(sessionStorage.getItem('user')) ? true : false
    return user ? children : <Navigate to="/"/>
}